import { render } from "./App.vue?vue&type=template&id=2237a363"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2237a363&lang=scss"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__